"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const utils_1 = require("./utils");
const aria_1 = require("./utils/aria");
const components_1 = require("./utils/InputElement/components");
const StyledLabel = app_1.styled.label `
  cursor: pointer;
`;
const StyledOption = (0, app_1.styled)(StyledLabel)((theme) => {
    var _a;
    return [
        components_1.inputStyle,
        (0, app_1.css)({ padding: theme.spacing.small }),
        app_1.styled.checked `
    border-color: ${theme.accent};
  `,
        theme.inputs.children,
        (_a = theme.inputs.choicegroup) === null || _a === void 0 ? void 0 : _a.label,
    ];
});
const ChoiceInputContext = (0, react_1.createContext)(undefined);
const StyledChoiceInput = app_1.styled.div `
  display: grid;
  gap: ${(theme) => theme.spacing.small};
  ${(theme) => { var _a; return (_a = theme.inputs.choicegroup) === null || _a === void 0 ? void 0 : _a.css; }}
`;
function ChoiceInputElem({ children, value, label, hasError, onChange, onBlur, className, multiple, disabled, }) {
    const handleChange = (0, react_1.useCallback)((ev) => {
        const choice = ev.currentTarget.value;
        let newValue = choice;
        if (multiple) {
            const curr = Array.isArray(value) ? value : value ? [value] : [];
            newValue = curr.includes(choice)
                ? curr.filter((e) => e !== choice)
                : [...curr, choice];
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(newValue);
    }, [onChange, onBlur, multiple, value]);
    const contextValue = (0, react_1.useMemo)(() => ({ onChange: handleChange, value, hasError }), [handleChange, hasError, value]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [label && ((0, jsx_runtime_1.jsx)(utils_1.Label, Object.assign({ inputKind: "choicegroup" }, (0, aria_1.aria)({ invalid: hasError, disabled: Boolean(disabled) }), { children: label }))), (0, jsx_runtime_1.jsx)(StyledChoiceInput, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(ChoiceInputContext.Provider, Object.assign({ value: contextValue }, { children: children })) }))] }));
}
function ChoiceInput(_a) {
    var { defaultValue, children: choices } = _a, props = __rest(_a, ["defaultValue", "children"]);
    return ((0, jsx_runtime_1.jsx)(utils_1.InputController, Object.assign({}, props, { render: (renderProps) => ((0, jsx_runtime_1.jsx)(ChoiceInputElem, Object.assign({}, renderProps, { children: choices }))), defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '' })));
}
exports.ChoiceInput = ChoiceInput;
function Option({ value, onClick, className, custom, disabled, children, }) {
    const id = (0, app_1.useCuid)();
    const choiceContext = (0, react_1.useContext)(ChoiceInputContext);
    if (!choiceContext) {
        return ((0, jsx_runtime_1.jsx)("div", { children: 'FATAL: Choice has to be contained by a <ChoiceGroup> component' }));
    }
    const { onChange, value: checked, hasError } = choiceContext;
    const isChecked = Array.isArray(checked)
        ? checked.includes(value)
        : checked === value;
    const Render = custom ? StyledLabel : StyledOption;
    return ((0, jsx_runtime_1.jsxs)(Render, Object.assign({ onClick: onClick, tabIndex: 0, className: className, onKeyDown: (ev) => /^(Enter| )$/u.test(ev.key) && ev.currentTarget.click(), htmlFor: id }, (0, aria_1.aria)({
        invalid: hasError,
        checked: isChecked,
        disabled: Boolean(disabled),
    }), { children: [(0, jsx_runtime_1.jsx)(utils_1.StyledHiddenCheckbox, { id: id, tabIndex: -1, type: "checkbox", value: value, checked: isChecked, onChange: onChange, disabled: disabled }), children] })));
}
ChoiceInput.Option = Option;
